
import CreativeCommons from "../../../assets/outline/CreativeCommons.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CreativeCommonsIcon({ className, dataTestid = "CreativeCommonsIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CreativeCommons data-testid={dataTestid} className={classes} {...rest} />
  );
}
